import { useRef } from "react";

const behavior = "smooth";

export const useScroll = () => {
  const scrollableRef = useRef<HTMLDivElement>(null);

  const scrollTo = (options: ScrollToOptions) => {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo
    scrollableRef.current?.scrollTo({ behavior, ...options });
  };

  const scrollIntoView = (options: ScrollIntoViewOptions) => {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
    scrollableRef.current?.scrollIntoView({ behavior, ...options });
  };

  return {
    scrollableRef,
    scrollTo,
    scrollIntoView,
  };
};
